import { Component, Input, Output, EventEmitter } from "@angular/core";
@Component({
  selector: "app-cb-email-image-preview",
  // standalone: true,
  // imports: [],
  templateUrl: "./cb-email-image-preview.component.html",
  styleUrls: ["./cb-email-image-preview.component.scss"],
})
export class ImagePreviewComponent {
  @Input() imageUrl!: string;
  @Input() templateName: string = "";
  @Output() closed = new EventEmitter<void>();

  closeModal() {
    this.closed.emit();
  }
}
